<template>
  <ca-modal
    ref="modal"
    size="small"
    title="Cadastrar nova lotação">
    <template slot="body">
      <stockings-form-page
        :is-valid.sync="isFormValid"
        :object.sync="stock"
        :is-modal="true"></stockings-form-page>
    </template>

    <ca-row slot="footer">
      <ca-col size="3">
        <ca-button full-width @click="$refs.modal.close()">
          Cancelar
        </ca-button>
      </ca-col>
      <ca-col offset="6" size="3">
        <ca-request-button
          :disabled="!isFormValid"
          :on-request="onSubmit"
          :on-request-success="onSubmitSuccess"
          :on-request-error="onSubmitError"
          theme="primary">
          Confirmar
        </ca-request-button>
      </ca-col>
    </ca-row>
  </ca-modal>
</template>

<script>
import StockingsFormPage from 'accountant/employer/stockings/StockingsFormPage';
import { createStock } from 'accountant/employer/stockings/stockingService';

export default {
  name: 'CreateStockingsModal',
  components: {
    StockingsFormPage,
  },
  data() {
    return {
      stock: {},
      isFormValid: null,
    };
  },
  methods: {
    onSubmit() {
      return createStock(this.stock);
    },
    onSubmitSuccess() {
      this.$emit('created');
      this.$refs.modal.close();
      this.$toaster.success('Lotação criada com sucesso!');
    },
    onSubmitError() {
      this.$toaster.error('Aconteceu um erro, por favor tente novamente.');
    },
  },
};
</script>

<style scoped>
::v-deep .ca-heading--title {
  display: none;
}

::v-deep .ca-page-default {
  border: none;
  padding: unset;
}

::v-deep .ca-footer {
  display: none;
}
</style>
